const isDefaultAvatar = avatar => avatar && avatar.match(/users\/default/i);

export default isDefaultAvatar;
